import { render, staticRenderFns } from "./RewardCardStat.vue?vue&type=template&id=0bc44642&scoped=true&"
import script from "./RewardCardStat.vue?vue&type=script&lang=js&"
export * from "./RewardCardStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc44642",
  null
  
)

export default component.exports